import { render } from "./WpeButtonGroup.vue?vue&type=template&id=4b99692b"
import script from "./WpeButtonGroup.vue?vue&type=script&lang=js"
export * from "./WpeButtonGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeButtonGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b99692b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b99692b', __exports__)) {
    api.reload('4b99692b', __exports__)
  }
  
  module.hot.accept("./WpeButtonGroup.vue?vue&type=template&id=4b99692b", () => {
    api.rerender('4b99692b', render)
  })

}


export default __exports__